import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

// Patent data imported from the Lextria Dashboard. Also kept in sessionStorage so a page
// refresh does not lose it (the hand-off link works only once); sessionStorage is per tab and
// is cleared when the tab closes, or by clearPrefill ("Clear" / "Discard imported data").
const STORAGE_KEY = "lextria_prefill";

function readStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function writeStored(value) {
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
}

const PrefillContext = createContext({
  prefill: null,
  setPrefill: () => {},
  clearPrefill: () => {},
});

export function PrefillProvider({ children }) {
  const [prefill, setPrefillState] = useState(readStored);
  const setPrefill = useCallback((value) => {
    writeStored(value);
    setPrefillState(value || null);
  }, []);
  const clearPrefill = useCallback(() => setPrefill(null), [setPrefill]);
  const value = useMemo(() => ({ prefill, setPrefill, clearPrefill }), [prefill, setPrefill, clearPrefill]);
  return <PrefillContext.Provider value={value}>{children}</PrefillContext.Provider>;
}

export function usePrefill() {
  return useContext(PrefillContext);
}

export default PrefillContext;
